<template>
  <el-dialog
    :title="$t('common.confirm')"
    :visible.sync="dialogVisible"
    width="30%"
    :before-close="handleClose"
  >
    <div align="center">
      <p>{{ $t('deleteAllocationOrder.confirmDelete') }}</p>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="close">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="confirmDelete">{{ $t('common.confirm') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { deleteAllocationOrder } from '@/api/goods/allocationOrderApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'DeleteAllocationOrder',
  data() {
    return {
      dialogVisible: false,
      deleteInfo: {}
    }
  },
  methods: {
    open(params) {
      this.deleteInfo = params
      this.dialogVisible = true
    },
    close() {
      this.dialogVisible = false
    },
    handleClose(done) {
      done()
    },
    async confirmDelete() {
      this.deleteInfo.shopId = getShopId()
      try {
        await deleteAllocationOrder(this.deleteInfo)
        this.$emit('listAssetInventory')
        this.$message.success(this.$t('common.submitSuccess'))
        this.close()
      } catch (error) {
        console.error('删除失败:', error)
        this.$message.error(error.message)
      }
    }
  }
}
</script>